import { useLanguage } from "@utils/hooks/useLanguage";
import { useTranslations } from "../../../../../../translation/TranslationContext";
import CoachesCard from "./CoachesCard";
import { T } from "@utils/enums";
import { useTheme } from "@stores/ThemeContext";
import { useVersion } from "@utils/hooks/useVersion";
import CoachesCardV2 from "./CoachesCardV2";

interface BenchProps {
    homeCoach: string;
    awayCoach: string;
    homeTeamName?: string | null;
    awayTeamName?: string | null;
    homeCountryCode?: string;
    awayCountryCode?: string;
    homeCard?: string;
    awayCard?: string;
}

const Coaches = ({ homeCoach, awayCoach, homeTeamName, awayTeamName, homeCountryCode, awayCountryCode, homeCard, awayCard }: BenchProps) => {
    const language = useLanguage();
    const t = useTranslations(language);
    const { isV1, isV2 } = useVersion();
    const { theme } = useTheme();
    
    const hasHomeCoach = homeCoach && homeCoach.trim() !== '';
    const hasAwayCoach = awayCoach && awayCoach.trim() !== '';
    const hasAnyCoach = hasHomeCoach || hasAwayCoach;
    
    if (!hasAnyCoach) {
        return null;
    }
    
    return (
        <div data-testid="coaches-container" className={`h-[103px] rounded-[4px]`}
            style={{ backgroundColor: isV1 ? (theme === T.LIGHT ? '#FFFFFF' : '#333333') : (theme === T.LIGHT ? '#FFFFFF' : '#222222') }}
        >
            <div data-testid="coaches-title" className="w-full h-[24px] flex justify-center items-center mt-[12px]
                            font-medium text-[16px] leading-[24px] text-monoX dark:text-monoY"
                style={{ marginBottom: isV1 ? '8px' : '0px' }}
            >
                {t[`InHouseStats.LineupCoaches`]}
            </div>

            <div data-testid="coaches-home-coach-container" className={`flex flex-row justify-between px-[8px] w-full`}>
                    <CoachesCardV2
                        coachName={homeCoach}
                        teamName={homeTeamName}
                        dataTestId="coaches-home-coach"
                        countryCode={homeCountryCode}
                        teamSide={"home"}
                        countryIcon={homeCountryCode}
                        isTemplate={!hasHomeCoach}
                        card={homeCard as "yellow" | "second_yellow" | "red" | undefined}
                    />
                    <CoachesCardV2
                        coachName={awayCoach}
                        teamName={awayTeamName}
                        dataTestId="coaches-away-coach"
                        countryCode={awayCountryCode}
                        teamSide={"away"}
                        countryIcon={awayCountryCode}
                        isTemplate={!hasAwayCoach}
                        card={awayCard as "yellow" | "second_yellow" | "red" | undefined}
                    />
                
            </div>
        </div>
    )
}

export default Coaches;